export default __webpack_public_path__ + "static/SOSWEETPINK-6489def6a006498a2f650a5190580098.png";